import {get} from 'lodash'
import stringFormat from 'string-format'
import {Ventrata} from 'types'

type Props = {
  config: object
  order: Ventrata.Order
}

export const Alcatraz = ({config, order}: Props) => {
  return <>{stringFormat(get(config, 'text', ''), {order})}</>
}
